import { faSave, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { useLang } from '../../../../../../../language'
import { useForm } from '../../../../../../../hooks/useForm'
import { useValidator } from '../../../../../../../hooks/useValidator'
import { getValuesParams, isStatusSucess } from '../../../../../../../helpers/helpers'
import { InputText } from '../../../../../../../components/Inputs'
import { ButtonSpinner } from '../../../../../../../components/ButtonSpinner/ButtonSpinner'
import { ModalStatusServer } from '../../../../../../../components/Modals/ModalStatusServer'
import { NivelIdiomaAdapters } from './controllers/nivelesidioma.adapter'
import { NivelIdiomaServices } from './controllers/nivelesidioma.service'

export const NivelIdioma = ({ showModal_TipoNoticias, handleCloseModal_TipoNoticias, fetchListado, formValuesSearch }: any) => {

    const Lang = useLang()

    const [formEstadoPersona, handleInputEstadoPersona, handleFormEstadoPersona, resetFormEstadoPersona]
        = useForm(NivelIdiomaAdapters.POST.send.schema({}))

    const [valuesValidationEstadoOferta, handleValidationEstadoOferta, handleResetValidationEstadoOferta] = useValidator({
        nivelidioma: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
        ordenidioma: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
    })

    // ----------- POST Relacion

    const [fetchTipoNoticiasPOST, fetchTipoNoticiasPOSTData] = NivelIdiomaServices.POST()

    const handleSubmitCrear = () => {

        if (handleValidationEstadoOferta(formEstadoPersona)) {
            fetchTipoNoticiasPOST({
                body: formEstadoPersona
            })
        }
    }

    useEffect(() => {
        if (isStatusSucess(fetchTipoNoticiasPOSTData.status)) {
            handleCloseModal_TipoNoticias()

            const urlParams = getValuesParams(formValuesSearch)

            fetchListado({
                params: {
                    ...urlParams
                }
            })
        }
    }, [fetchTipoNoticiasPOSTData])

    // --------------- PATCH Relacion

    const [fetchTipoNoticiasPATCH, fetchTipoNoticiasPATCHData] = NivelIdiomaServices.PATCH(showModal_TipoNoticias.payload?.form?.id)

    const handleSubmitEditar = () => {

        fetchTipoNoticiasPATCH({
            body: {
                ...formEstadoPersona,
            }
        })
    }


    useEffect(() => {
        if (isStatusSucess(fetchTipoNoticiasPATCHData.status)) {
            handleCloseModal_TipoNoticias()
            const urlParams = getValuesParams(formValuesSearch)

            fetchListado({
                params: {
                    ...urlParams
                }
            })
        }
    }, [fetchTipoNoticiasPATCHData])

    // ---------- DELETE Relacion

    const [fetchTipoNoticiasDELETE, fetchTipoNoticiasDELETEData] = NivelIdiomaServices.DELETE(showModal_TipoNoticias.payload?.form?.id)

    const handleSubmitEliminar = () => {
        fetchTipoNoticiasDELETE()
    }

    useEffect(() => {
        if (isStatusSucess(fetchTipoNoticiasDELETEData.status)) {
            handleCloseModal_TipoNoticias()
            const urlParams = getValuesParams(formValuesSearch)

            fetchListado({
                params: {
                    ...urlParams
                }
            })
        }
    }, [fetchTipoNoticiasDELETEData])

    // Acciones mostrar ocultar modal

    useEffect(() => {

        if (showModal_TipoNoticias.value) {

            if (showModal_TipoNoticias.payload?.form?.id) {
                handleFormEstadoPersona({
                    ...showModal_TipoNoticias.payload?.form
                })
            }

        } else {
            resetFormEstadoPersona()
        }

    }, [showModal_TipoNoticias.value])

    return (
        <>
            <Modal show={showModal_TipoNoticias.value} onHide={handleCloseModal_TipoNoticias} size='lg' id='ModalRegistro'>
                <Modal.Header className='border-bottom-0 py-4'>
                    <Modal.Title className='h5'>
                        {showModal_TipoNoticias.payload.action === 'EDIT' ? Lang('EDITAR_NIVEL_IDIOMA') : Lang('NUEVO_NIVEL_IDIOMA')}
                    </Modal.Title>
                    <button type="button" className="btn-close mx-0" aria-label="Close" onClick={handleCloseModal_TipoNoticias}></button>
                </Modal.Header>
                <Modal.Body className='px-4 py-0'>
                    <Form className='row'>

                        <Form.Group className="mb-3 col-12">
                            <InputText
                                label={`${Lang('NIVEL_IDIOMA')}:`}
                                name='nivelidioma'
                                value={formEstadoPersona.nivelidioma}
                                onChange={handleInputEstadoPersona}
                                fetchData={fetchTipoNoticiasPOSTData}
                                validation={valuesValidationEstadoOferta}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3 col-lg-4">
                            <InputText
                                label={`${Lang('ORDEN_IDIOMA')}:`}
                                name='ordenidioma'
                                type='number'
                                value={formEstadoPersona.ordenidioma}
                                onChange={handleInputEstadoPersona}
                                fetchData={fetchTipoNoticiasPOSTData}
                                validation={valuesValidationEstadoOferta}
                            />
                        </Form.Group>

                        {/* <Form.Group className="mb-3 col-12">
                            <InputText
                                label={`${Lang('DESCRIPCION')}:`}
                                name='descripcion'
                                asParam='textarea'
                                rows={4}
                                value={formEstadoPersona.descripcion}
                                onChange={handleInputEstadoPersona}
                                fetchData={fetchTipoNoticiasPOSTData}
                                validation={valuesValidationEstadoOferta}
                            />
                        </Form.Group> */}

                    </Form>
                </Modal.Body>
                <Modal.Footer className='border-0 justify-content-between'>
                    {
                        showModal_TipoNoticias.payload?.action === 'EDIT' ? <>
                            <ButtonSpinner
                                variant="danger" type="submit" className="ms-2"
                                handleSubmit={handleSubmitEliminar} fetchDataLoading={[fetchTipoNoticiasDELETEData.loading]}
                                value={Lang('ELIMINAR')} icon={<FontAwesomeIcon icon={faTrash} />}
                            />
                            <ButtonSpinner
                                variant="secondary" type="submit" className="me-2"
                                handleSubmit={handleSubmitEditar} fetchDataLoading={[fetchTipoNoticiasPATCHData.loading]}
                                value={Lang('GUARDAR')} icon={<FontAwesomeIcon icon={faSave} />}
                            />
                        </> : <>
                            <div></div>
                            <ButtonSpinner
                                variant="secondary" type="submit" className="me-2 ms-auto"
                                handleSubmit={handleSubmitCrear} fetchDataLoading={[fetchTipoNoticiasPOSTData.loading]}
                                value={Lang('CREAR')} icon={<FontAwesomeIcon icon={faSave} />}
                            />
                        </>
                    }
                </Modal.Footer>
            </Modal>

            <ModalStatusServer fetchData={fetchTipoNoticiasPOSTData} />

            <ModalStatusServer fetchData={fetchTipoNoticiasPATCHData} onlySuccess={true} />

            <ModalStatusServer fetchData={fetchTipoNoticiasDELETEData} onlySuccess={true} />

        </>
    )
}
